import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logCoreUsage } from 'owa-analytics';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import { getAccountScopeUserSettings } from 'owa-session-store';
import { getSelectedAccountMailboxInfo } from 'owa-account-source-list-store';

type EventNames =
    | 'ClickedGmailCloudCacheAccountFromAccountSwitcher'
    | 'AddCloudCacheAccountClickedFromAccountSwitcher'
    | 'AddCloudCacheAccountClickedFromCallout'
    | 'AddCloudCacheAccountClickedFromSettings'
    | 'AddCloudCacheConfig'
    | 'RemoveCloudCacheConfig';

type AllEventNames = `${EventNames}NonPremium` | `${EventNames}Unknown` | EventNames;

export function logUsageBasedOnPremiumFlag(eventName: EventNames, customData: any = null): void {
    const mailboxInfo = getModuleContextMailboxInfo();

    // we are unable to identify whether a user is premium or not as this information
    // is not loaded when the user is accessing its cloud cache account.
    // thus, we cannot rely solely on the IsPremiumConsumerMailbox flag for now
    /* eslint-disable-next-line no-restricted-properties  -- (https://aka.ms/OWALintWiki)
     * Adding IsShadowMailbox to restricted properties/methods.
     *	> 'IsShadowMailbox' is restricted from being used. IsCloudCache/IsShadowMailbox should be resolved in ECS as a filter in a feature flight if possible. */
    const customEventName: AllEventNames = getUserConfiguration().SessionSettings?.IsShadowMailbox
        ? `${eventName}Unknown`
        : /* eslint-disable-next-line owa-custom-rules/no-reflow-methods  -- (https://aka.ms/OWALintWiki)
         * Reflow related methods should not be used, see https://aka.ms/multiaccountlinter
         *	> Do Not Use Reflow: The getSelectedAccountMailboxInfo function should not be used for Respond multi-account support. */
        getAccountScopeUserSettings(getSelectedAccountMailboxInfo()).SessionSettings
              ?.IsPremiumConsumerMailbox
        ? eventName
        : `${eventName}NonPremium`;

    if (customEventName === 'ClickedGmailCloudCacheAccountFromAccountSwitcher') {
        logCoreUsage('ClickedGmailCloudCacheAccountFromAccountSwitcher', mailboxInfo, customData);
    } else if (customEventName === 'AddCloudCacheAccountClickedFromAccountSwitcher') {
        logCoreUsage('AddCloudCacheAccountClickedFromAccountSwitcher', mailboxInfo, customData);
    } else if (customEventName === 'AddCloudCacheAccountClickedFromCallout') {
        logCoreUsage('AddCloudCacheAccountClickedFromCallout', mailboxInfo, customData);
    } else if (customEventName === 'AddCloudCacheAccountClickedFromSettings') {
        logCoreUsage('AddCloudCacheAccountClickedFromSettings', mailboxInfo, customData);
    } else if (customEventName === 'AddCloudCacheConfig') {
        logCoreUsage('AddCloudCacheConfig', mailboxInfo, customData);
    } else if (customEventName === 'RemoveCloudCacheConfig') {
        logCoreUsage('RemoveCloudCacheConfig', mailboxInfo, customData);
    } else if (customEventName === 'ClickedGmailCloudCacheAccountFromAccountSwitcherNonPremium') {
        logCoreUsage(
            'ClickedGmailCloudCacheAccountFromAccountSwitcherNonPremium',
            mailboxInfo,
            customData
        );
    } else if (customEventName === 'AddCloudCacheAccountClickedFromAccountSwitcherNonPremium') {
        logCoreUsage(
            'AddCloudCacheAccountClickedFromAccountSwitcherNonPremium',
            mailboxInfo,
            customData
        );
    } else if (customEventName === 'AddCloudCacheAccountClickedFromCalloutNonPremium') {
        logCoreUsage('AddCloudCacheAccountClickedFromCalloutNonPremium', mailboxInfo, customData);
    } else if (customEventName === 'AddCloudCacheAccountClickedFromSettingsNonPremium') {
        logCoreUsage(
            'AddCloudCacheAccountClickedFromSettingsNonPremiumUnknown',
            mailboxInfo,
            customData
        );
    } else if (customEventName === 'AddCloudCacheConfigNonPremium') {
        logCoreUsage('AddCloudCacheConfigNonPremium', mailboxInfo, customData);
    } else if (customEventName === 'RemoveCloudCacheConfigNonPremium') {
        logCoreUsage('RemoveCloudCacheConfigNonPremium', mailboxInfo, customData);
    } else if (customEventName === 'ClickedGmailCloudCacheAccountFromAccountSwitcherUnknown') {
        logCoreUsage(
            'ClickedGmailCloudCacheAccountFromAccountSwitcherUnknown',
            mailboxInfo,
            customData
        );
    } else if (customEventName === 'AddCloudCacheAccountClickedFromAccountSwitcherUnknown') {
        logCoreUsage(
            'AddCloudCacheAccountClickedFromAccountSwitcherUnknown',
            mailboxInfo,
            customData
        );
    } else if (customEventName === 'AddCloudCacheAccountClickedFromCalloutUnknown') {
        logCoreUsage('AddCloudCacheAccountClickedFromCalloutUnknown', mailboxInfo, customData);
    } else if (customEventName === 'AddCloudCacheAccountClickedFromSettingsUnknown') {
        logCoreUsage('AddCloudCacheAccountClickedFromSettingsUnknown', mailboxInfo, customData);
    } else if (customEventName === 'AddCloudCacheConfigUnknown') {
        logCoreUsage('AddCloudCacheConfigUnknown', mailboxInfo, customData);
    } else if (customEventName === 'RemoveCloudCacheConfigUnknown') {
        logCoreUsage('RemoveCloudCacheConfigUnknown', mailboxInfo, customData);
    }
}
